import { api } from './client.js';

export const getJobFairLinks = async () => api.get('/company/job-fair/links');
export const createJobFairLink = async (payload) => api.post('/company/job-fair/links', payload);
export const updateJobFairLinkStatus = async (id, status) =>
  api.patch(`/company/job-fair/links/${id}/status`, { status });
export const deleteJobFairLink = async (id) => api.delete(`/company/job-fair/links/${id}`);

export const getJobFairLeads = async () => api.get('/company/job-fair/leads');
export const convertJobFairLead = async (id) => api.post(`/company/job-fair/leads/${id}/convert`, {});
export const downloadJobFairLeadResume = async (id) => api.get(`/company/job-fair/leads/${id}/resume`);

export const getPublicJobFairLink = async (token) => api.get(`/public/job-fair/${token}`);
export const submitPublicJobFairLead = async (token, payload, resumeFile) => {
  const formData = new FormData();
  formData.append('fullName', payload.fullName || '');
  formData.append('email', payload.email || '');
  formData.append('phone', payload.phone || '');
  formData.append('experienceLevel', payload.experienceLevel || '');
  formData.append('skills', JSON.stringify(payload.skills || []));
  if (payload.college) formData.append('college', payload.college);
  if (payload.course) formData.append('course', payload.course);
  if (payload.graduationYear) formData.append('graduationYear', payload.graduationYear);
  if (payload.notes) formData.append('notes', payload.notes);
  if (resumeFile) formData.append('resume', resumeFile);
  return api.post(`/public/job-fair/${token}/submit`, formData);
};
